import ReactDOM from 'react-dom/client';
import { v2Component } from '../../index';
import { TenantContext } from '../../context/tenant-context';
import { ToastContainer } from 'react-toastify';
import React from 'react';
import { ProductTaxCategoryInput } from './product-tax-category-input';
import { ItemTaxCategoryInput } from './item-tax-category-input';

export function initItemTaxCategoryInput(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('item-tax-category');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        const props = {
          ...dataset,
        };

        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <ItemTaxCategoryInput {...props} />
            </TenantContext.Provider>,
          ),
        );
      };
      bootstrap();
    }
  });
}

export function initProductTaxCategoryInput(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('product-tax-category');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        const props = {
          ...dataset,
        };

        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <ProductTaxCategoryInput {...props} />
            </TenantContext.Provider>,
          ),
        );
      };
      bootstrap();
    }
  });
}
